import React from 'react'
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';
// import pdfBG from "assets/images/admission-form.png"
import QRCode from 'qrcode'

const pdfBG = "https://res.cloudinary.com/codevpk/image/upload/v1738266697/miscellaneous/codevpk-admission-form_bstmey.png"

export default function PDF({ data }) {
    const { campus = {}, course = {}, registrationNumber, fullName, fatherName, cnic, email, gender, dob, address, phone, photoURL } = data
    const { title, batch, session, netFee } = course;

    const qrCodeDataUrl = QRCode.toDataURL(`${registrationNumber}`);

    return (
        <Document
            title={`CoDev Admission Form for ${fullName}`}
            author={window.appName}
            subject={`CoDev Admission Form for ${fullName}`}
        >
            <Page size="A4" style={styles.page}>
                <View style={styles.pdfBG}><Image source={{ uri: pdfBG }}></Image></View>
                <Image source={photoURL} style={styles.photo} />
                <Text style={[styles.textSmall, { position: "absolute", top: 34, right: 199 }]}>{window.FormatPhoneNormal(campus.phone)}</Text>
                <Text style={[styles.textSmall, { position: "absolute", top: 54.5, right: 199 }]}>{window.FormatPhoneNormal(campus.whatsapp)}</Text>
                <Text style={[{ position: "absolute", top: 74, right: campus.name === "Al Seeraht" ? 100 : 149.5, fontSize: campus.name === "Al Seeraht" ? 10 : 12, marginTop: campus.name === "Al Seeraht" ? 2 : 0 }]}>{campus.address}</Text>

                <View style={styles.content}>
                    <Text style={styles.textSmall}>{fullName}</Text>
                    <View style={styles.row}>
                        <View style={[styles.col, { marginTop: 1 }]}>
                            <Text style={styles.textSmall}>{fatherName}</Text>
                        </View>
                        <View style={[styles.col, styles.col2]}>
                            <Text style={styles.textSmall}>{window.FormatCNIC(cnic)}</Text>
                        </View>
                    </View>
                    <View style={styles.row}>
                        <View style={styles.col}>
                            <Text style={styles.textSmallCapitalize}>{gender}</Text>
                        </View>
                        <View style={[styles.col, { position: "absolute", left: 285 }]}>
                            <Text style={styles.textSmall}>{window.dateFormat(dob, "DD-MMM-YYYY")}</Text>
                        </View>
                    </View>
                    <Text style={[styles.textSmall, { marginTop: 13 }]}>{email}</Text>
                    <Text style={[styles.textSmall, { marginTop: 13 }]}>{address}</Text>
                    <Text style={[styles.textSmall, { marginTop: 13 }]}>{title} (Batch-{batch})</Text>
                    <View style={styles.row}>
                        <View style={[styles.col, { marginTop: 1.5 }]}>
                            <Text style={[styles.textSmallCapitalize]}>{registrationNumber}</Text>
                        </View>
                        <View style={[styles.col, styles.col2, { marginTop: 1.5 }]}>
                            <Text style={[styles.textSmallCapitalize]}>{session}</Text>
                        </View>
                    </View>
                </View>
                <View style={[{ marginTop: 11, width: 520, top: 160, left: 38 }]}>
                    <View style={[{ display: "flex", flexDirection: "row", justifyContent: "space-between" }]}>
                        <View style={[{ width: 250 }]}>
                            {/* <Text style={[{ fontSize: 9 }]}>1 - Please color print this Admission Form and bring it to {campus.name}, {campus.address}.</Text> */}
                            <Text style={[{ fontSize: 9 }]}>1 - Please color print this Admission Form and submit it at {campus.name}, {campus.address}, along with copies of <Text style={{ fontWeight: "bold" }}>CNIC/B-Form, Father's CNIC, Highest Qualification, and the non-refundable fee of PKR {netFee?.toLocaleString()}</Text>.</Text>
                        </View>
                        <View style={[{ width: 235 }]}>
                            <Text style={[{ fontSize: 9 }]}>3 - The official course/training start date can be confirmed at the CoDev campus. Please visit the campus to submit the fee and secure your seat.</Text>
                        </View>
                    </View>
                    <View style={[{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop: 5 }]}>
                        <View style={[{ width: 250 }]}>
                            <Text style={[{ fontSize: 9, fontWeight: "bold" }]}>2 - Note: Online students can submit documents and fee online.</Text>
                            <Text style={[{ fontSize: 9 }]}><Text style={{ fontWeight: "bold" }}>Fee via JazzCash: 0335-6609060</Text> or contact for other options.</Text>
                            {/* <Text style={[{ fontSize: 9 }]}>2 - Please come along with <Text style={{ fontWeight: "bold" }}>(CNIC/B-Form copy, Father's CNIC copy, Highest Qualification copy)</Text> and fee of <Text style={{ fontWeight: "bold" }}>PKR {netFee?.toLocaleString()}</Text>.</Text> */}
                            {/* <Text style={[{ fontSize: 9 }]}>2 - Bring copies of <Text style={{ fontWeight: "bold" }}>CNIC/B-Form, Father's CNIC, Highest Qualification, and fee of PKR {netFee?.toLocaleString()}</Text> (non-refundable).</Text> */}
                            {/* <Text style={[{ fontSize: 9, fontWeight: "bold" }]}>Note: The fee is non-refundable.</Text> */}
                        </View>
                        <View style={[{ width: 235 }]}>
                            <Text style={[{ fontSize: 9 }]}>4 - We have very few seats available and one section so come in between 09:00 AM to 06:00 PM (Mon to Sat) to submit documents.</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.cardContent, { marginTop: 25.5, position: 'absolute', top: 402.7 }]}>
                    <View style={[styles.cardRow, { justifyContent: 'flex-end' }]}>
                        <View style={[styles.colR]}>
                            <Image src={qrCodeDataUrl} style={{ width: 35, height: 35, position: 'absolute', right: 124 }} />
                        </View>
                        <View style={[styles.colR, styles.col2R]}>
                            <Image src={qrCodeDataUrl} style={{ width: 35, height: 35, position: 'absolute', right: 122 }} />
                        </View>
                    </View>
                    <View style={[styles.cardRow, { marginTop: 42.3 }]}>
                        <View style={[styles.colR]}>
                            <Image src={photoURL} style={{ width: 57, height: 57, borderRadius: 12, position: 'absolute', right: 124 }} />
                        </View>
                        <View style={[styles.colR, styles.col2R]}>
                            <Image src={photoURL} style={{ width: 57, height: 57, borderRadius: 12, marginBottom: 8, marginLeft: 2 }} />
                        </View>
                    </View>
                </View>

                <View style={{ display: 'flex', flexDirection: 'row', position: 'absolute', top: 399.7 }}>
                    <View style={{ top: 140, left: 95 }}>
                        <View style={{ width: 220, textAlign: "center" }}>
                            <Text style={[styles.textWhite]}>{fullName}</Text>
                        </View>
                    </View>
                    <View style={{ top: 140, left: 60 }}>
                        <View style={{ width: 220, textAlign: "center" }}>
                            <Text style={[styles.textWhite]}>{fullName}</Text>
                        </View>
                    </View>
                </View>

                <View style={{ width: 450, top: 552, left: 135, position: 'absolute' }} >
                    <View style={[styles.cardRow, { marginLeft: 25 }]}>
                        <View style={[styles.colR]}>
                            <Text style={styles.textSmallWhite}>{registrationNumber}</Text>
                        </View>
                        <View style={[styles.colR, styles.col2R, { marginLeft: 3 }]}>
                            <Text style={styles.textSmallWhite}>{registrationNumber}</Text>
                        </View>
                    </View>
                    <View style={[styles.cardRow, { marginTop: 7, marginLeft: -29 }]}>
                        <View style={[styles.colR]}>
                            <Text style={{ fontSize: 5, color: "#ffffff", marginTop: 2 }}>{title} ({batch})</Text>
                        </View>
                        <View style={[styles.colR, styles.col2R, { marginLeft: 5 }]}>
                            <Text style={{ fontSize: 5, color: "#ffffff", marginTop: 2 }}>{title} ({batch})</Text>
                        </View>
                    </View>
                    <View style={[styles.cardRow, { marginTop: 8, marginLeft: -35 }]}>
                        <View style={[styles.colR, { marginLeft: -5 }]}>
                            <Text style={styles.textSmallWhite}>{window.FormatCNIC(cnic)}</Text>
                        </View>
                        <View style={[styles.colR, styles.col2R, { marginLeft: 5 }]}>
                            <Text style={styles.textSmallWhite}>{window.FormatCNIC(cnic)}</Text>
                        </View>
                    </View>
                    <View style={[styles.cardRow, { marginTop: 7, marginLeft: -11 }]}>
                        <View style={[styles.colR, { marginLeft: 5 }]}>
                            <Text style={styles.textSmallWhite}>{window.FormatPhoneNormal(phone)}</Text>
                        </View>
                        <View style={[styles.colR, styles.col2R, { marginLeft: 3 }]}>
                            <Text style={styles.textSmallWhite}>{window.FormatPhoneNormal(phone)}</Text>
                        </View>
                    </View>
                </View>

                <View style={{ position: "absolute", width: 525, top: 720.1, left: 70 }} >
                    <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <View style={{ width: 220 }}>
                            <Text style={styles.textSmallCapitalize}>{fullName}</Text>
                        </View>
                        <View style={{ width: 248 }}>
                            <Text style={{ fontSize: 10 }}>{title} ({batch})</Text>
                        </View>
                    </View>
                    <View style={{ marginTop: 11, display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <View style={{ width: 220, marginLeft: 54 }}>
                            <Text style={styles.textSmallCapitalize}>{registrationNumber}</Text>
                        </View>
                    </View>
                </View>

            </Page>
        </Document>
    )
}

const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        flexDirection: "column"
    },
    pdfBG: {
        position: "absolute",
        top: 0,
        width: "100%"
    },
    photo: {
        width: 71.5,
        height: 70.5,
        position: "absolute",
        top: 25.7,
        right: 21.2,
    },
    textSmall: {
        fontSize: 12
    },
    textWhite: {
        fontSize: 9,
        color: '#ffffff'
    },
    textSmallWhite: {
        fontSize: 7,
        color: '#ffffff'
    },
    textSmallCapitalize: {
        fontSize: 12,
        textTransform: "capitalize"
    },
    content: {
        width: 435,
        top: 145,
        left: 138,
    },
    row: {
        marginTop: 13,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
    },
    col: {
        width: 162,
    },
    col2: {
        width: 152,
    },
    cardContent: {
        width: 441,
        top: 144,
        left: 138,
    },
    cardRow: {
        marginTop: 8,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    },
    colR: {
        width: 180,
    },
    col2R: {
        width: 180,
    },
});